import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_01.png";
import Img_Two from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_02.png";
import Img_Three from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_03.png";
import Img_Four from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_04.png";
import Img_Five from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_05.png";
import Img_Six from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_06.png";
import Img_Seven from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_07.png";
import Img_Eight from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_08.png";
import Img_Nine from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_09.png";
import Img_Ten from "./../../../../sources/imgs/SHERLOCK/SHERLOCK_10.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function SHERLOCK (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> SHERLOCK.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Sherlock</span> es una <span className="span-pink">herramienta de código abierto</span> que permite <span className="span-white">buscar nombres de usuario</span> en <span className="span-blue">múltiples plataformas</span> y <span className="span-blue">redes sociales</span>. Se utiliza ampliamente en tareas de <i className="span-white">OSINT (Open Source Intelligence)</i> para <span className="span-pink">identificar la huella digital</span> de una <span className="span-white">persona en internet</span>.
            </p>

            <p>
                El <span className="span-white">comando</span> base para ejecutar <span className="span-white">instrucciones</span> de <span className="span-yellow">Sherlock</span> es:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock"
            />

            <p>
                Imagen de <span className="span-white">ejemplo</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 1. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando principal de SHERLOCK."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Instalación de Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Sherlock</span> es una <span className="span-pink">herramienta</span> que debe ser <span className="span-white">instalada</span>, si contamos con una maquina <i className="span-pink">Kali Linux</i>, podemos <span className="span-white">instalarla</span>, utilizando el siguiente <span className="span-pink">comando</span>: 
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install sherlock"
            />

            <p>
                Tal como se muestra en la <span className="span-pink">siguiente imagen</span> de <span className="span-white">ejemplo</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 2. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"2. Comando de instalación de SHERLOCK."}
            />

            <p>
                O puedes <span className="span-pink">consultar</span> Información desde el <span className="span-white">repositorio oficial</span> de <span className="span-yellow">Sherlock</span> en <i className="span-pink">GitHub</i>: <a href="https://github.com/sherlock-project/sherlock" className="span-white">Repositorio oficial de Sherlock</a>.
            </p>

            <p>
                Puedes copiar en tu <span className="span-pink">portapapeles</span> el <span className="span-white">enlace</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "https://github.com/sherlock-project/sherlock"
            />

            <p>
                <span className="span-yellow">Nota:</span> No olvides <span className="span-pink">aceptar la instalación</span> de las <span className="span-white">dependencias necesarias</span> para el <span className="span-white">uso correcto</span> de la <span className="span-pink">herramienta</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Consultar versión de Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si lograste instalar <span className="span-yellow">Sherlock</span> de <span className="span-pink">manera correcta</span>, puedes consultar la <span className="span-white">version</span> de la <span className="span-pink">herramienta</span>.
            </p>

            <p>
                Para ello, puedes <span className="span-white">utilizar</span> el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock --version"
            />

            <p>
                Tal como la <span className="span-pink">imagen</span> siguiente:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando de version de SHERLOCK."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Información y ayuda de Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si desea <span className="span-pink">consultar</span> la <span className="span-white">Información</span> de <span className="span-blue">comandos</span> y <span className="span-blue">parametros</span> para el uso de la <span className="span-white">herramienta</span>, podemos ejecutar el <span className="span-pink">comando</span> siguiente:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock -h"
            />

            <p>
                El cual permite <span className="span-white">visualizar</span> la <span className="span-pink">documentación</span> e <span className="span-pink">Información necesaria</span> y <span className="span-pink">util</span> para el uso.
            </p>

            <p>
                Tal como se muestra en la <span className="span-white">imagen</span>:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando de ayuda de SHERLOCK."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Uso de Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una vez <span className="span-pink">instalado</span> <span className="span-yellow">Sherlock</span>, podemos <span className="span-white">utilizarlo</span> con el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock <nombre-usuario>"
            />

            <p>
                Donde:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">&lt;nombre-usuario&gt;</span> <span className="span-blue">-></span> <span className="span-pink">Nombre de usuario el cual se desea reconocer.</span>
                    </p>
                </li>
            </ul>

            <p>
                Como el <span className="span-pink">siguiente ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock juanitoPerez"
            />

            <p>
                Tal como se muestra en la <span className="span-white">siguiente imagen</span> de <span className="span-pink">ejemplo</span>:
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"5. Uso de comando de SHERLOCK."}
            />

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"6. Uso de comando de SHERLOCK."}
            />

            <p>
                <span className="span-yellow">Sherlock</span> tambien permite el paso de <span className="span-white"> multiples nombres de usuario</span> en <span className="span-pink">comandos</span>.
            </p>

            <p>
                <span className="span-pink">Ejecutandose</span> de la <span className="span-white">siguiente manera</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock <nombre-usuario1> <nombre-usuario2>"
            />

            <p>
                Tomando el <span className="span-pink">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock juanitoPerez juanPerez"
            />

            <p>
                Visualizando:
            </p>

            <Img
                img = {Img_Seven}
                alt = {"Imagen 7. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"7. Uso de comando de multiples usuarios de SHERLOCK."}
            />

            <Img
                img = {Img_Eight}
                alt = {"Imagen 8. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"8. Uso de comando de multiples usuarios de SHERLOCK."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Almacenar resultados de Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                La herramienta de <span className="span-yellow">Sherlock</span> nos permite <span className="span-white">almacenar los resultados</span> de una busqueda realizada en un <span className="span-pink">archivo</span> de formato <i className="span-white">.txt</i>.
            </p>

            <p>
                Para ello, agregamos a nuestro <span className="span-pink">comando simple</span>, el <span className="span-pink">parametro</span> <i className="span-white">--output &lt;nombre-archivo&gt;.txt</i>
            </p>

            <p>
                Tal como la <span className="span-pink">siguiente estructura</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock <nombre-usuario> --output <nombre-archivo>.txt"
            />

            <p>
                Donde:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">&lt;nombre-usuario&gt;</span> <span className="span-blue">-></span> <span className="span-pink">Nombre de usuario el cual se desea reconocer.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">&lt;nombre-archivo&gt;</span> <span className="span-blue">-></span> <span className="span-pink">Nombre de archivo el cual se desea crear con los resultados obtenidos.</span>
                    </p>
                </li>
            </ul>

            <p>
                Como el <span className="span-pink">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sherlock juanitoPerez --output resultados.txt"
            />

            <p>
                Imagen de <span className="span-white">demostración</span>:
            </p>

            <Img
                img = {Img_Nine}
                alt = {"Imagen 9. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"9. Almacenamiento de resultados en .txt en SHERLOCK."}
            />

            <Img
                img = {Img_Ten}
                alt = {"Imagen 10. SHERLOCK."}
                title = {"Descripcción de imagen."}
                text = {"10. Visualización de resultados en .txt en SHERLOCK."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Consideranciones éticas de Sherlock.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Recuerda:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        Usa <span className="span-yellow">Sherlock</span> solo con fines <span className="span-white">educativos</span> o <span className="span-white">legales</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">NO invadas la privacidad</span> de otras <span className="span-pink">personas</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">NO uses la información</span> obtenida para <span className="span-blue">doxeo</span>, <span className="span-blue">acoso</span> o <span className="span-blue">amenazas</span>.
                    </p>
                </li>
            </ul>
        </>
    );
}